export default {
    parseDate: function (date, isToday = true) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${isToday ? date.getDate(): ''}`
    },
}